import { AfterViewInit, Directive, ElementRef, NgZone, OnDestroy } from '@angular/core';

@Directive({
  selector: 'ag-grid-angular[appFitGridToViewport]',
  standalone: true
})
export class FitGridToViewportDirective implements AfterViewInit, OnDestroy {
  private observer?: ResizeObserver;
  private frame = 0;
  private readonly onResize = () => this.scheduleMeasure();

  constructor(private element: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngAfterViewInit(): void {
    this.zone.runOutsideAngular(() => {
      window.addEventListener('resize', this.onResize);
      this.observer = new ResizeObserver(this.onResize);
      const section = this.element.nativeElement.closest('section');
      if (section) this.observer.observe(section);
      this.scheduleMeasure();
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  private scheduleMeasure(): void {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      const grid = this.element.nativeElement;
      const available = Math.floor(window.innerHeight - grid.getBoundingClientRect().top - 48);
      const height = Math.max(180, available);
      if (Math.abs(grid.clientHeight - height) > 1) grid.style.height = `${height}px`;
    });
  }
}
